import React from 'react';
import { Instagram, Facebook, Linkedin, MapPin, Phone, Mail, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0a0a0a] border-t border-gold/20 pt-16 pb-8 px-5 sm:px-6 md:px-8" data-id="element-139">
      <div className="max-w-7xl mx-auto" data-id="element-140">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16" data-id="element-141">
          {/* Column 1: Brand */}
          <div className="space-y-6" data-id="element-142">
            <img src="https://cdn.magicpatterns.com/uploads/nanucanRnpywk3r4f9gVxT/IMG_6635.jpg" alt="Doctor Ecommerce Logo" className="h-12 w-auto" data-id="element-143" />
            <p className="text-gold italic font-medium text-lg" data-id="element-144">
              La cura para clínicas estancadas.
            </p>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-145">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a clínicas y consultorios en todo Estados
              Unidos, transformando presupuestos publicitarios en máquinas de
              generación de pacientes y citas diarias.
            </p>
            <div className="flex items-center space-x-4" data-id="element-146">
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-147">
                <Instagram className="w-6 h-6" data-id="element-148" />
              </a>
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-149">
                <Facebook className="w-6 h-6" data-id="element-150" />
              </a>
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-151">
                <Linkedin className="w-6 h-6" data-id="element-152" />
              </a>
              {/* Custom TikTok SVG since it's not in lucide-react standard set */}
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-153">
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" data-id="element-154">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-155" />
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2: Servicios */}
          <div data-id="element-156">
            <h3 className="text-gold font-bold text-lg mb-6 tracking-wide" data-id="element-157">
              SERVICIOS
            </h3>
            <ul className="space-y-4 text-gray-300 text-sm" data-id="element-158">
              <li data-id="element-159">Meta Ads · Google Ads · TikTok Ads · YouTube Ads</li>
              <li data-id="element-160">Email · SMS · Retargeting Automatizado</li>
              <li data-id="element-161">Automatización con IA para Citas 24/7</li>
              <li data-id="element-162">Funnels Clínicos por Especialidad</li>
              <li data-id="element-163">Blindaje Digital & Anti-Ban</li>
              <li data-id="element-164">PR Digital & Posicionamiento en Medios</li>
              <li data-id="element-165">CRM & Data Tracking Avanzado</li>
              <li data-id="element-166">Video Marketing IA · SEO · Branding</li>
              <li data-id="element-167">Gestión de Reputación · Google Maps</li>
              <li data-id="element-168">Diseño Web · Landing Pages · CRO</li>
            </ul>
          </div>

          {/* Column 3: Recursos */}
          <div data-id="element-169">
            <h3 className="text-gold font-bold text-lg mb-6 tracking-wide" data-id="element-170">
              RECURSOS
            </h3>
            <ul className="space-y-4 text-gray-300 text-sm" data-id="element-171">
              <li data-id="element-172">
                <a href="#" className="hover:text-gold transition-colors flex items-center" data-id="element-173">
                  <span className="text-gold mr-2" data-id="element-174">›</span> Blog de Estrategia
                </a>
              </li>
              <li data-id="element-175">
                <a href="#" className="hover:text-gold transition-colors flex items-center" data-id="element-176">
                  <span className="text-gold mr-2" data-id="element-177">›</span> Casos de Éxito
                </a>
              </li>
              <li data-id="element-178">
                <a href="#" className="hover:text-gold transition-colors flex items-center" data-id="element-179">
                  <span className="text-gold mr-2" data-id="element-180">›</span> Política de
                  Privacidad
                </a>
              </li>
              <li data-id="element-181">
                <a href="#" className="hover:text-gold transition-colors flex items-center" data-id="element-182">
                  <span className="text-gold mr-2" data-id="element-183">›</span> Términos y
                  Condiciones
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contacto */}
          <div data-id="element-184">
            <h3 className="text-gold font-bold text-lg mb-6 tracking-wide" data-id="element-185">
              CONTACTO DIRECTO
            </h3>
            <ul className="space-y-4 text-gray-300 text-sm mb-8" data-id="element-186">
              <li className="flex items-start" data-id="element-187">
                <MapPin className="w-5 h-5 text-gold mr-3 flex-shrink-0" data-id="element-188" />
                <span data-id="element-189">1001 WATER ST, TAMPA FL 33602</span>
              </li>
              <li className="flex items-center" data-id="element-190">
                <Phone className="w-5 h-5 text-gold mr-3 flex-shrink-0" data-id="element-191" />
                <span data-id="element-192">(402) 872-0639</span>
              </li>
              <li className="flex items-center" data-id="element-193">
                <Mail className="w-5 h-5 text-gold mr-3 flex-shrink-0" data-id="element-194" />
                <span data-id="element-195">doctor.ecommerceus@gmail.com</span>
              </li>
            </ul>

            <div className="space-y-4" data-id="element-196">
              <a href="https://wa.me/14028720639" target="_blank" rel="noopener noreferrer" className="w-full bg-emerald hover:bg-emerald-600 text-white font-bold py-3 px-4 rounded flex items-center justify-center transition-colors" data-id="element-197">
                <MessageCircle className="w-5 h-5 mr-2" data-id="element-198" />
                Habla con un Especialista
              </a>
              <button onClick={() => document.getElementById('contact-form')?.scrollIntoView({
              behavior: 'smooth'
            })} className="w-full bg-gold hover:bg-yellow-400 text-carbon font-bold py-3 px-4 rounded flex items-center justify-center transition-colors" data-id="element-199">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-200">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-201" />
                </svg>
                RESERVAR DIAGNÓSTICO
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 pb-4 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8" data-id="element-202">
          {/* Partners */}
          <div className="w-full lg:w-auto" data-id="element-203">
            <h4 className="text-gray-500 text-xs font-bold tracking-widest mb-4 uppercase" data-id="element-204">
              Partners Certificados y Tecnología de Élite
            </h4>
            <div className="flex flex-wrap gap-3" data-id="element-205">
              <div className="bg-white px-3 py-1.5 rounded flex items-center justify-center text-xs font-bold text-gray-800" data-id="element-206">
                Meta Business Partner
              </div>
              <div className="bg-white px-3 py-1.5 rounded flex items-center justify-center text-xs font-bold text-gray-800" data-id="element-207">
                Google Ads Partner
              </div>
              <div className="bg-white px-3 py-1.5 rounded flex items-center justify-center text-xs font-bold text-gray-800" data-id="element-208">
                Shopify Experts
              </div>
            </div>
          </div>

          {/* Mini Form */}
          <div className="w-full lg:w-auto" data-id="element-209">
            <h4 className="text-gray-500 text-xs font-bold tracking-widest mb-4 uppercase" data-id="element-210">
              ¿Quieres que te contactemos?
            </h4>
            <form className="flex flex-col sm:flex-row gap-2" onSubmit={e => e.preventDefault()} data-id="element-211">
              <input type="text" placeholder="Tu Nombre" className="bg-transparent border border-white/20 text-white text-sm rounded px-3 py-2 w-full sm:w-32 focus:border-gold outline-none" data-id="element-212" />
              <input type="email" placeholder="Tu Email" className="bg-transparent border border-white/20 text-white text-sm rounded px-3 py-2 w-full sm:w-32 focus:border-gold outline-none" data-id="element-213" />
              <input type="tel" placeholder="Tu Teléfono" className="bg-transparent border border-white/20 text-white text-sm rounded px-3 py-2 w-full sm:w-32 focus:border-gold outline-none" data-id="element-214" />
              <input type="text" placeholder="Nombre de tu Empresa" className="bg-transparent border border-white/20 text-white text-sm rounded px-3 py-2 w-full sm:w-40 focus:border-gold outline-none" data-id="element-215" />
              <button type="button" onClick={() => document.getElementById('contact-form')?.scrollIntoView({
              behavior: 'smooth'
            })} className="bg-gold hover:bg-yellow-400 text-carbon font-bold text-sm px-4 py-2 rounded transition-colors" data-id="element-216">
                ENVIAR
              </button>
            </form>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center mt-12 text-gray-600 text-xs" data-id="element-217">
          © 2026 Doctor Ecommerce. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}